import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=886d6348&"
import script from "./CollapseTransition.vue?vue&type=script&lang=js&"
export * from "./CollapseTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports